var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8597 7.26221V12.9681C11.8597 13.1145 11.8016 13.2548 11.6981 13.3583C11.5946 13.4617 11.4543 13.5199 11.308 13.5199H3.03213C2.8858 13.5199 2.74547 13.4617 2.642 13.3583C2.53853 13.2548 2.4804 13.1145 2.4804 12.9681V6.34745H6.53171L9.84261 3.03711H3.03213C2.11957 3.03711 1.37695 3.77973 1.37695 4.69228V12.9681C1.37695 13.8807 2.11957 14.6233 3.03213 14.6233H11.308C12.2205 14.6233 12.9632 13.8807 12.9632 12.9681V6.15821L11.8597 7.26221Z",
    fill: "#1E4133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5202 4.04056L14.3004 3.26043C14.4058 3.15864 14.4898 3.03688 14.5477 2.90225C14.6055 2.76763 14.6359 2.62283 14.6372 2.47632C14.6385 2.3298 14.6106 2.1845 14.5551 2.04889C14.4996 1.91328 14.4177 1.79008 14.3141 1.68647C14.2104 1.58287 14.0872 1.50093 13.9516 1.44545C13.816 1.38997 13.6707 1.36205 13.5242 1.36332C13.3777 1.3646 13.2329 1.39504 13.0983 1.45287C12.9636 1.5107 12.8419 1.59476 12.7401 1.70015L11.96 2.48029L13.5202 4.04056Z",
    fill: "#1E4133"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.179 3.25977L7.27832 7.16101L6.8877 9.1119L8.83859 8.72128L12.7398 4.82059L11.179 3.25977Z",
    fill: "#1E4133"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/Notes.d033bd75d42a772babbb2091a54a1fc7.svg";
export { ForwardRef as ReactComponent };